import LazyVideo from "../components/LazyVideo";

export default function WhatIf() {
  return (
    <div className="bg-gradient-to-t from-slate-100 to-royalBlue">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-4 p-4 max-w-screen-xl mx-auto">
        {/* Horizontal Text Box - Move this BELOW the first horizontal image to appear on second row */}
        <div className="col-span-3 sm:col-span-2 lg:col-span-2 row-span-1 aspect-video bg-white rounded-2xl shadow-md p-6 flex items-center justify-center text-center lg:grid-cols-2">
          <div>
            <h1 className="text-royalBlue text-xl pt-2 font-semibold">
              🎬 What If: A Short Film on Everyday Choices
            </h1>
            <p className="text-m text-gray-800">
              {" "}
              “What If” is a lighthearted short film by G.C.M. Production that
              blends humor and reflection to explore how small choices can lead
              to unexpected outcomes. Brought to life by a talented cast and
              crew, it’s a sweet and thoughtful story — with hints of more to
              come.
            </p>
          </div>
        </div>
        {/* Horizontal Video */}
        <div className="aspect-video col-span-3 bg-black rounded-2xl overflow-hidden shadow-md">
          <LazyVideo
            autoPlay
            muted
            loop
            controls
            playsInline
            className="w-full h-full object-fit"
          >
            <source
              src="../Imgs/WhatIf/WhatIfTrailerSMALLER.mp4"
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </LazyVideo>
        </div>

        {/* Vertical Image */}
        <div className="col-span-1 sm:col-span-1 lg:col-span-2 row-span-2 bg-gray-100 rounded-2xl overflow-hidden shadow-md">
          <img
            src="../Imgs/WhatIf/WHAT IFChealseaFilmFestival.png"
            alt=""
            className="w-full h-full object-fit"
          />
        </div>
        {/* Vertical Image */}
        <div className="col-span-1 sm:col-span-1 lg:col-span-2 row-span-2 bg-gray-100 rounded-2xl overflow-hidden shadow-md sm:col-span-2 ">
          <img
            src="../Imgs/WhatIf/whatif.jpg"
            alt=""
            className="w-full h-full object-fit"
          />
        </div>
        {/* Vertical Image */}
        <div className="col-span-1 sm:col-span-1 lg:col-span-1 row-span-1 bg-gray-100 rounded-2xl overflow-hidden shadow-md sm:col-span-2 ">
          <img
            src="../Imgs/WhatIf/MariaAward.jpg"
            alt=""
            className="w-full h-full object-fit"
          />
        </div>
        {/* Vertical Image */}
        <div className="col-span-1 sm:col-span-1 lg:col-span-1 row-span-1 bg-gray-100 rounded-2xl overflow-hidden shadow-md sm:col-span-2 ">
          <img
            src="../Imgs/WhatIf/Award.jpg"
            alt=""
            className="w-full h-full object-fit"
          />
        </div>
      </div>
    </div>
  );
}
